import React from "react";
import "./Common_Title_3.css";
import { Link } from "react-router-dom";

const Common_Title_3 = ({ titleText, subText, hideSeeAll , seelink }) => {
  return (
    <div className="Common_Title_3">
      <div className="center_div">
        <img src="/assets/images/header/lotus.png" className="lotus_img" />
        <p className="title_text">{titleText}</p>
      </div>

      {!hideSeeAll && (
        <div className="right_side_div">
          <Link to={seelink}><p className="see_all_text" >See All</p></Link>
        </div>
      )}
    </div>
  );
};

export default Common_Title_3;
